import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

interface TableRowProps {
  className?: string;
  trColor?: string;
}

const TableRow = ({
  children,
  className,
  trColor,
}: PropsWithChildren<TableRowProps>) => {
  return (
    <tr className={classNames({ [className]: className, [trColor]: trColor })}>
      {children}
    </tr>
  );
};

export default TableRow;
